import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select } from 'antd'
import BankingModal from '../../../../components/People/Member/Modal/Banking'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import IconText from '../../../../elements/IconText'
import CountrySelect from '../../../../elements/Select/Country'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import { get, isEmpty } from 'lodash'
import { dateVal, sessionItem, strVal } from '../../../../modules/Utils'
import React, { Component, Fragment } from 'react'
import { compose, withState } from 'recompose'
import CurrencySelect from '../../../../elements/Select/Currency'

const { TextArea } = Input

const { MonthPicker } = DatePicker

const StatusSelect = compose(
  withSelectFetch({
    dropdown: 'bank',
    name: 'status',
    cache: true,
  }),
  withSpinning,
  withSort
)(CustomSelect)

const TypeSelect = compose(
  withSelectFetch({
    dropdown: 'bank',
    name: 'type',
    cache: true,
  }),
  withSpinning,
  withSort
)(CustomSelect)

class BankDetails extends Component {
  state = { BankSelectCmp: Select, currencyCount: 0 }

  componentDidMount() {
    const company = strVal(this.props, 'contract.company._id')
    if (!isEmpty(company)) {
      const url = `banks/?owner=${company}`
      const BankSelectCmp = compose(
        withUrlFetch({
          name: 'banks',
          url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      this.setState({
        BankSelectCmp,
        url,
      })
    }
  }

  onChangeBank = (bankID) => {
    const bank = sessionItem(`banks_${this.state.url}_dropdown`, bankID, '_id')
    this.setState({
      bank: bank,
    })
  }
  addCurrency = () => {
    this.setState((prvState) => ({
      currencyCount: prvState.currencyCount + 1,
    }))
  }
  removeCurrency = () => {
    this.setState((prvState) => ({
      currencyCount: prvState.currencyCount <= 0 ? 0 : prvState.currencyCount - 1,
    }))
  }

  render() {
    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { contract, lender, showBank, visibleBank, member } = this.props

    const isInterCompany = contract.type == 'interCompany'
    console.log(isInterCompany)
    return (
      <Fragment>
        <BankingModal
          employee={lender}
          bank={this.state.bank}
          member={member}
          type={'view'}
          visible={visibleBank}
          handleCancel={() => showBank(false)}
        />
        <Form layout="horizontal">
          <Row>
            <Row>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Bank'}>
                  {getFieldDecorator('bank.bank', {
                    initialValue: get(contract, 'bank.bank'),
                    rules: [{ required: true, message: "Bank can't be empty" }],
                  })(<Input placeholder={'Bank Name'} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Account Type'}>
                  {getFieldDecorator('accountType', {
                    initialValue: get(contract, 'bank.accountType') || get(contract, 'accountType'),
                    rules: [{ required: true, message: "Account Type can't be empty" }],
                  })(<TypeSelect placeholder={'Account Type'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Status'}>
                  {getFieldDecorator('bank.status', {
                    initialValue: get(contract, 'bank.status'),
                    rules: [
                      {
                        required: true,
                        message: "Account Status can't be empty",
                      },
                    ],
                  })(<StatusSelect placeholder={'Account Status'} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
              <h3 style={{ color: 'rgb(43,187,143' }}>ACCOUNT HOLDER DETAILS</h3>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Account Name'}>
                  {getFieldDecorator('bank.accountName', {
                    initialValue: get(contract, 'bank.accountName'),
                    rules: [{ required: true, message: "Account Name can't be empty" }],
                  })(<Input placeholder={'Account Name'} />)}
                </Form.Item>
              </Col>
            </Row>
            {this.props.form.getFieldValue('accountType') !== 'Card' && (
              <>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Account Number'}>
                      {getFieldDecorator('bank.accountNumber', {
                        initialValue: get(contract, 'bank.accountNumber'),
                        rules: [
                          this.props.form.getFieldValue('accountType') !== 'Card' && {
                            required: true,
                            message: "Account Number can't be empty ",
                          },
                        ],
                      })(<Input placeholder={'Account Number'} />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'IBAN'}>
                      {getFieldDecorator('bank.iban', {
                        initialValue: get(contract, 'bank.iban'),
                      })(<Input placeholder={'IBAN'} />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Is MultiCurrency'}>
                      {getFieldDecorator('bank.isMultiCurrency', {
                        initialValue: get(contract, 'bank.isMultiCurrency'),
                        valuePropName: 'checked',
                      })(<Checkbox />)}
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {this.props.form.getFieldValue('accountType') === 'Card' && (
              <>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label="Card Number">
                      {getFieldDecorator('card.number', {
                        initialValue: get(contract, 'card.number'),
                        rules: [
                          {
                            required: true,
                            message: "Card Number can't be empty ",
                          },
                        ],
                      })(<Input placeholder="Card Number" />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label="Card Expiry">
                      {getFieldDecorator('card.expiry', {
                        initialValue: dateVal(contract, 'card.expiry'),
                        rules: [
                          {
                            required: true,
                            message: "Card Expiry can't be empty ",
                          },
                        ],
                      })(<MonthPicker format={'YYYY/MM'} />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Account Number'}>
                      {getFieldDecorator('bank.accountNumber', {
                        initialValue: get(contract, 'bank.accountNumber'),
                        rules: [
                          this.props.form.getFieldValue('accountType') !== 'Card' && {
                            required: true,
                            message: "Account Number can't be empty ",
                          },
                        ],
                      })(<Input placeholder={'Account Number'} />)}
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            <Row>
              {this.props.form.getFieldValue('bank.isMultiCurrency') !== true ? (
                <Col span={12}>
                  <Form.Item {...formItemLayoutRow} label={'Currency'}>
                    {getFieldDecorator('bank.currency', {
                      initialValue: get(contract, 'bank.currency'),
                      rules: [{ required: true, message: "Currency can't be empty" }],
                    })(<CurrencySelect placeholder={'Currency'} />)}
                  </Form.Item>
                </Col>
              ) : (
                <>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Main Currency'}>
                      {getFieldDecorator('bank.currency', {
                        initialValue: get(contract, 'bank.currency'),
                        rules: [{ required: true, message: "Currency can't be empty" }],
                      })(<CurrencySelect placeholder={'Currency'} />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={`Multi Currencies`}>
                      {getFieldDecorator(`bank.multiCurrency`, {
                        initialValue: get(contract, `bank.multiCurrency`),
                        rules: [
                          {
                            required: true,
                            message: "Multi Currencies can't be empty",
                          },
                        ],
                      })(<CurrencySelect mode="multiple" placeholder={`Multi Currencies`} />)}
                    </Form.Item>
                  </Col>
                </>
              )}
            </Row>

            <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
              <h3 style={{ color: 'rgb(43,187,143' }}>BRANCH DETAILS</h3>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Branch Name'}>
                  {getFieldDecorator('bank.branchName', {
                    initialValue: get(contract, 'bank.branchName'),
                    rules: [{ required: true, message: "Branch Name can't be empty" }],
                  })(<Input placeholder={'Branch Name'} />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Country'}>
                  {getFieldDecorator('bank.address.country', {
                    initialValue: get(contract, 'bank.address.country'),
                    rules: [{ required: true, message: "Country can't be empty" }],
                  })(<CountrySelect placeholder={'Country'} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item {...formItemLayoutRow} label={'Branch Address'}>
                  {getFieldDecorator('bank.address.label', {
                    initialValue: get(contract, 'bank.address.label'),
                    rules: [{ required: true, message: "Address can't be empty" }],
                  })(<Input placeholder={'Branch Address'} />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'BIC/SWIFT'}>
                  {getFieldDecorator('bank.swiftCode', {
                    initialValue: get(contract, 'bank.swiftCode'),
                    rules: [
                      {
                        required: true,
                        message: "BIC/SWIFT Code can't be empty ",
                      },
                    ],
                  })(<Input placeholder="SWIFT Code" />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label="BSB / SORT Code">
                  {getFieldDecorator('bank.bsb', {
                    initialValue: get(contract, 'bank.bsb'),
                  })(<InputNumber style={{ width: 100 }} placeholder="BSB / SORT Code" />)}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label="Branch Code">
                  {getFieldDecorator('bank.branchCode', {
                    initialValue: get(contract, 'bank.branchCode'),
                  })(<Input placeholder="Branch Code" />)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...formItemLayoutRow} label={'Requires Intermediary'}>
                  {getFieldDecorator('bank.isIbank', {
                    initialValue: get(contract, 'bank.isIbank'),
                    valuePropName: 'checked',
                  })(<Checkbox />)}
                </Form.Item>
              </Col>
            </Row>
            {this.props.form.getFieldValue('bank.isIbank') === true && (
              <>
                <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
                  <h3 style={{ color: 'rgb(43,187,143' }}>INTERMEDIARY DETAILS</h3>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Account Name'}>
                      {getFieldDecorator('bank.ibank.accountName', {
                        initialValue: get(contract, 'bank.ibank.accountName'),
                        rules: [
                          {
                            required: true,
                            message: "Account Name can't be empty",
                          },
                        ],
                      })(<Input placeholder={'Account Name'} />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Currency'}>
                      {getFieldDecorator('bank.ibank.currency', {
                        initialValue: get(contract, 'bank.ibank.currency'),
                        rules: [{ required: true, message: "Currency can't be empty" }],
                      })(<CurrencySelect placeholder={'Currency'} />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Account Number'}>
                      {getFieldDecorator('bank.ibank.accountNumber', {
                        initialValue: get(contract, 'bank.ibank.accountNumber'),
                        rules: [
                          this.props.form.getFieldValue('accountType') !== 'Card' && {
                            required: true,
                            message: "Account Number can't be empty ",
                          },
                        ],
                      })(<Input placeholder={'Account Number'} />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'IBAN'}>
                      {getFieldDecorator('bank.ibank.iban', {
                        initialValue: get(contract, 'bank.ibank.iban'),
                      })(<Input placeholder={'IBAN'} />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label="Bank Name">
                      {getFieldDecorator('bank.ibank.name', {
                        initialValue: get(contract, 'bank.ibank.name'),
                      })(<Input placeholder="Bank Name" />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label="Branch">
                      {getFieldDecorator('bank.ibank.branch', {
                        initialValue: get(contract, 'bank.ibank.branchName'),
                      })(<Input placeholder="Branch" />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label="SWIFT Code">
                      {getFieldDecorator('bank.ibank.swift', {
                        initialValue: get(contract, 'bank.ibank.swift'),
                      })(<Input placeholder="SWIFT Code" />)}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item {...formItemLayoutRow} label="Address">
                      {getFieldDecorator('bank.ibank.address.label', {
                        initialValue: get(contract, 'bank.ibank.address.label'),
                      })(<Input placeholder="Address" />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item {...formItemLayoutRow} label={'Country'}>
                      {getFieldDecorator('bank.ibank.address.country', {
                        initialValue: get(contract, 'bank.ibank.address.country'),
                        rules: [{ required: true, message: "Country can't be empty" }],
                      })(<CountrySelect placeholder={'Country'} />)}
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </Row>
        </Form>
      </Fragment>
    )
  }
}

export default compose(Form.create(), withState('visibleBank', 'showBank', false))(BankDetails)
